const amplify_conf = {
  Auth: {
    identityPoolId: 'eu-central-1:ce5eff54-6a0c-4e44-a096-35571e88fca5',
    region: 'eu-central-1',
    identityPoolRegion: 'eu-central-1',
    userPoolId: 'eu-central-1_5WIid6f5S',
    userPoolWebClientId: '3mkmcsedbfhs72ebkekkanlbll',
    mandatorySignIn: false
  },
  API: {
    endpoints: [
      {
        name: 'RobotexPublicAPI',
        endpoint: 'https://skg96mbttd.execute-api.eu-central-1.amazonaws.com/prod'
      }
    ],
    'aws_appsync_graphqlEndpoint': 'https://zi2b3v5lt5bflcapa42rmkg4gm.appsync-api.eu-central-1.amazonaws.com/graphql',
    'aws_appsync_region': 'eu-central-1',
    'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS'
  }
};

export default amplify_conf;



// WEBPACK FOOTER //
// ./src/conf/amplify.conf.js